const translations = {
  // Common elements
  "loading": "ஏற்றுகிறது...",
  "error": "பிழை",
  "success": "வெற்றி",
  "close": "மூடு",
  "save": "சேமி",
  "cancel": "ரத்து செய்",
  "continue": "தொடர்",
  "back": "பின்னால்",
  "next": "அடுத்து"
};

export default translations;
